import { render, staticRenderFns } from "./ImageCropped.vue?vue&type=template&id=22fe8e80&scoped=true"
import script from "./ImageCropped.vue?vue&type=script&lang=js"
export * from "./ImageCropped.vue?vue&type=script&lang=js"
import style0 from "./ImageCropped.vue?vue&type=style&index=0&id=22fe8e80&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe8e80",
  null
  
)

export default component.exports